import React, {useEffect, useState} from "react";
import { useNavigate } from 'react-router-dom';
import { Tooltip, Typography, Avatar, Chip } from '@mui/material';

import ButtonMain from "../../components/button/Button_main";

import emailOn from '../../assets/envelope-robot-on.svg'
import emailOff from '../../assets/envelope-robot-off.svg'

const JobCard = (props) => {

    const [job, setJob] = useState(props.job)
    const [jobActive, setJobActive] = useState(false)
    const navigate = useNavigate();

    useEffect(()=>{setJob(props.job); console.log('props.job >>',props.job)},[props.job])


    const hasJobActive = (closeData) => {

        const currentDate = new Date();
        const closingDate = new Date(closeData);

        //console.log('hasJobActive', closingDate)

        // Check if the target date has passed today
        const hasPassed = closingDate > currentDate;
        //setJobActive(hasPassed)
        return hasPassed;
        
    }

    //open job button
    
    const handleOpenJob = (uploadedCount, id, refId, name, autoEmailEnable, jobActive) => {

        if(uploadedCount > 0){
            navigate(`/review/${id}`)
        }
        else{
            navigate(`/upload-cv/${id}`)
        }

        //console.log('xxxxx',hasJobActive(jobActive))

        props.jobDetails(hasJobActive(jobActive), name, refId, id, autoEmailEnable)
        sessionStorage.setItem("jobRef",refId )
        sessionStorage.setItem("jobName", name)
        sessionStorage.setItem("jobStatus", hasJobActive(jobActive))
        sessionStorage.setItem("autoEmailEnable", autoEmailEnable)
        console.log('autoEmailEnable', autoEmailEnable)
    }

    //convert timestamp

     const covertTimestamp = (timestamp) => {

        if (!timestamp) return 'N/A';
        
        const date = new Date(JSON.parse(timestamp));

        const formattedDate = date.toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'short',
            day: 'numeric'
        });
      
        return formattedDate;

    }   

    //JD avatar letters

    const stringAvatar = (name) => {
        console.log(' ', name)
        let splitText = name.split(' ');

        return {
          children: `${splitText.length > 0 ? name.split(' ')[0][0] : ''}${ splitText.length > 1 ? name.split(' ')[1][0] :''}`,
        };
    }

    return(
            <div className="card-container bg-white rounded-xl w-full p-5 my-2">
                <div className="flex items-start justify-between pb-4">
                    {/* <Avatar alt={job.title} src="/static/images/avatar/2.jpg" className="bg-primary w-16 h-16"/> */}
                    <Avatar {...stringAvatar(job.title)} className="bg-primary w-16 h-16 uppercase"/>
                    <div className="flex flex-col items-end">
                        <div className="flex items-center">
                            <Tooltip title={job.mailAutomationEnabled ? `Email automation is enabled` : `Email automation is disabled`}>
                                <div className={`rounded-lg ${job.mailAutomationEnabled ? 'bg-green': 'bg-red'} bg-opacity-20 mr-2 h-8 w-12 flex justify-center items-center`}>
                                    <img src={job.mailAutomationEnabled ? emailOn : emailOff} alt="email icon" className="w-[1.25rem] cursor-pointer" />
                                </div>
                            </Tooltip>
                            <Chip label={`${hasJobActive(job.closingDate) ? 'Active':'Inactive'}`} className={`${hasJobActive(job.closingDate) ? 'bg-green bg-opacity-20 text-green':'text-red bg-red  bg-opacity-20'} 'font-semibold rounded-lg`}/>
                        </div>
                        <Typography component={'div'} className="mt-3 text-right" variant="text14Light">{`Created ${covertTimestamp(job.openingDate)}`}</Typography>
                    </div>
                </div>
                <div className="mt-4">
                    <Typography component={'div'} variant="textBaseLight" className="truncate min-h-[1.5rem]">{job.department}</Typography>
                    <Typography component={'div'} variant="text20" className="truncate">{job.title}</Typography>
                    <Typography component={'div'} variant="text14Light" className="truncate min-h-[1.238rem] mt-1">{job.referenceId}</Typography>
                    <div className="job-details mt-4 pb-4 border-b border-solid border-0 border-cultured">
                        <Typography component={'div'} variant="textBaseLight" className="truncate">Pending : <span className="ml-1 text-primary font-semibold">{job.pendingCvCount}</span></Typography>
                        <Typography component={'div'} variant="textBaseLight" className="truncate">Shortlisted : <span className="ml-1 text-primary font-semibold">{job.shortlistedCvCount}</span></Typography>
                        <Typography component={'div'} variant="textBaseLight" className="truncate">Uploaded : <span className="ml-1 text-primary font-semibold">{job.processedCvCount}</span></Typography>
                        <Typography component={'div'} variant="textBaseLight" className="truncate">Closing date : <span className={`ml-1 ${hasJobActive(job.closingDate) ? 'text-green':'text-red'} font-semibold`}>{covertTimestamp(job.closingDate)}</span></Typography>
                    </div>
                    <div className="job-action mt-4 flex justify-between items-center">
                        <Typography 
                            component={'div'} 
                            className="cursor-pointer underline hover:text-gray" 
                            align="right" 
                            variant="textBase" 
                            onClick={()=> {
                                props.setOpenJobView(true); 
                                props.setPreviewPopupData({'ref':job.referenceId, 'title':job.title, 'department':job.department, 'jdDescription':job.requirements})
                            }}
                            >
                                Preview job
                            </Typography>
                        <ButtonMain 
                            variant='secondary' 
                            type='button' 
                            disabled={false} 
                            name='Open job'
                            class='capitalize'
                            onClick={()=>handleOpenJob(job.processedCvCount, job.id, job.referenceId, job.title, job.mailAutomationEnabled, job.closingDate)}
                        />
                    </div>
                </div>
            </div>
    )
}

export default JobCard;